<template>
  <div>
    <v-form ref="form"
            v-model="valid"
    >
      <v-card style="padding: 20px">
        <v-card-title>New quality level</v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            v-model.number="newLevel.width"
            label="Width"
            type="number"
            :rules="[rules.required, rules.maxIntNumber]"
          ></v-text-field>
          <v-text-field
            autofocus
            v-model.number="newLevel.bitrate"
            label="Bitrate in Mbit/s"
            type="number"
            :rules="[rules.required, rules.maxLongNumber]"
          ></v-text-field>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <div class="row row--end">
            <v-btn text
                   @click="cancel"
            >Cancel</v-btn>
            <v-btn text
                   color="primary"
                   @click="add"
                   :disabled="!valid"
            >Add quality level
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { HubConnection } from "@microsoft/signalr";

export default {
  name:  "AddLocationsForm",
  props: {
    connection: HubConnection,
  },
  data() {
    return {
      valid:    false,
      newLevel: { width: 0, bitrate: 0 },
      rules:    {
        required:      (value) => !!value || "Required",
        maxIntNumber:  (value) => value < 2147483647 || "Max width is 2147483647",
        maxLongNumber: (value) => value < 9223372036854 || "Max bitrate is 9223372036854",
      },
    };
  },
  methods: {
    add() {
      this.connection
        .invoke("AddQualityLevel", {width: this.newLevel.width, bitrate: this.newLevel.bitrate * 1000000})
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("encode-updated", response.entity);
            this.$emit("ok");
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((reason) => {
          this.$emit("failure", reason);
        });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style></style>
